import { DEFAULT_BARCODE_CONTENT } from "@app/components/editor/workspace/golden-layout-definitions";

import { Component, ViewChild, ElementRef } from "@angular/core";
import { UserService } from "../../services/user.service";
import { User } from "../../data/user";
import { LoaderService } from "../../services/loader.service";
import { fadeInOutAnimation, savingButtonAnimation } from "../../animations";
import { ListingService } from "@app/services/listing.service";

import { Angulartics2 } from "angulartics2";
import { FileService } from "@app/services/file.service";
import { ChangeDetectorRef } from "@angular/core";
import { GoldenLayoutService } from "@app/services/golden-layout.service";
import { BaseEditorComponent } from "@app/components/platform/base-editor.component";
import { Listing } from "@app/data/listing";
import { DomSanitizer } from "@angular/platform-browser";
import { CatalogService } from "@app/services/catalog.service";
import { BarcodeFormat, ResourceService } from "@app/services/resource.service";
import { OrderService } from "@app/services/order.service";
import { Order } from "@app/data/order";
import { SupermodalComponent } from "@app/components/common/supermodal.component";
import * as _ from "underscore";

@Component({
  templateUrl: "./barcode.component.html",
  animations: [fadeInOutAnimation, savingButtonAnimation],
})
export class BarcodeComponent extends BaseEditorComponent {
  @ViewChild("barcodeStartSupermodal")
  barcodeStartSupermodal: SupermodalComponent;
  @ViewChild("barcodeStopSupermodal")
  barcodeStopSupermodal: SupermodalComponent;
  @ViewChild("barcodeCreatedSupermodal")
  barcodeCreatedSupermodal: SupermodalComponent;
  // nodes = [
  //   {
  //     id: 1,
  //     name: 'root1',
  //     children: [
  //       { id: 2, name: 'child1' },
  //       { id: 3, name: 'child2' }
  //     ]
  //   },
  //   {
  //     id: 4,
  //     name: 'root2',
  //     children: [
  //       { id: 5, name: 'child2.1' },
  //       {
  //         id: 6,
  //         name: 'child2.2',
  //         children: [
  //           { id: 7, name: 'subsub' }
  //         ]
  //       }
  //     ]
  //   }
  // ];
  formats: BarcodeFormat[] = [];
  orders: Order[] = [];
  automaticBarcodeGenerationEnabled: boolean = false;
  isUpdatingBarcodeGeneration: boolean = false;
  protected hasAccessBarcodeBulkOrder: boolean;
  protected orderId: number = null;

  selectedMoments = [];
  width: number;
  height: number;
  unit: string = "in";
  selectedOrder: Order;
  barcodeCreationStatus = "";
  hasAccessBarcodeGeneration: boolean;
  offset = 1;

  constructor(
    private angulartics2: Angulartics2,
    sanitizer: DomSanitizer,
    catalogService: CatalogService,
    listingService: ListingService,
    userService: UserService,
    loaderService: LoaderService,
    fileService: FileService,
    changeDetectorRef: ChangeDetectorRef,
    goldenLayoutService: GoldenLayoutService,
    private resourceService: ResourceService,
    private orderService: OrderService
  ) {
    super(
      sanitizer,
      catalogService,
      listingService,
      userService,
      loaderService,
      fileService,
      changeDetectorRef,
      goldenLayoutService
    );
    this.field = "barcode";
    this.angulartics2.eventTrack.next({ action: "Opened Barcode Page" });
    this.resourceService.getBarcodeFormats().then((barcodeFormats) => {
      this.formats = barcodeFormats;
    });
    this.checkAutomaticBarcodeGeneration();

    var beginOfDay = new Date();
    beginOfDay.setHours(0);
    beginOfDay.setMinutes(0);
    beginOfDay.setSeconds(0);
    var currentDate = new Date();
    this.selectedMoments = [beginOfDay, currentDate];
    this.userService
      .hasAccess("barcode-generation")
      .then((hasAccess) => (this.hasAccessBarcodeGeneration = hasAccess));

    this.userService
      .hasAccess("barcode-bulk-order")
      .then((hasAccessBarcodeBulkOrder) => {
        console.log("hasAccessBarcodeBulkOrder", hasAccessBarcodeBulkOrder);
        this.hasAccessBarcodeBulkOrder = hasAccessBarcodeBulkOrder;
      });
    this.searchOrders();
  }

  protected setUserModel(user: User) {
    user.barcode = user.barcode || {
      html: "",
      width: 2.5,
      height: 0.75,
      zoom: 1,
      multiple_per_page: false,
      include_variants: true,
      structure: DEFAULT_BARCODE_CONTENT,
    };
    user.barcode.structure = user.barcode.structure || DEFAULT_BARCODE_CONTENT;
    super.setUserModel(user);
  }

  protected initDocumentUrl(baseUrl: string) {
    this.documentURL = `${baseUrl}/api/v2/barcodes/download?l=`;
  }

  protected initComponent() {
    super.initComponent();
  }

  // protected getPDFURL(): string {
  //   //always send listing
  //   var param = encodeURIComponent(JSON.stringify(this.listing)) + '&local=1';
  //   return `${this.documentURL}${param}`;
  // }

  protected searchOrders() {
    this.orderService
      .getOrders(
        this.orderId,
        this.selectedMoments[0],
        this.selectedMoments[1],
        100
      )
      .then((orders) => {
        this.orders = orders;
      });
  }

  protected checkAutomaticBarcodeGeneration(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.isUpdatingBarcodeGeneration = true;
      this.userService.webhookCount("listing").then((count) => {
        this.isUpdatingBarcodeGeneration = false;
        this.automaticBarcodeGenerationEnabled = count > 0;
        resolve(this.automaticBarcodeGenerationEnabled);
      });
    });
  }

  protected selectOrder($event, order) {
    this.selectedOrder = order;
    $event.preventDefault();

    this.orderService.getListingsForOrder(order.id).then((listings) => {
      this.generateListings(listings);
    });
  }

  protected enableAutomaticBarcodeGeneration(enable: boolean) {
    if (enable) {
      this.angulartics2.eventTrack.next({
        action: "Enabled Automatic Barcode Generation",
      });
    } else {
      this.angulartics2.eventTrack.next({
        action: "Disabled Automatic Barcode Generation",
      });
    }
    this.isUpdatingBarcodeGeneration = true;
    this.userService.updateWebhook("listing", enable).then(() => {
      this.isUpdatingBarcodeGeneration = false;
      this.checkAutomaticBarcodeGeneration().then((enabled) => {
        if (enabled) {
          this.createBarcodeIfNeeded();
          this.barcodeStartSupermodal.open();
        } else {
          this.barcodeStopSupermodal.open();
        }
      });
    });
  }

  protected prepareListing() {
    this.createBarcodeIfNeeded();
  }

  protected prepareListings() {
    this.createBarcodesIfNeeded();
  }

  protected createBarcodesIfNeeded() {
    if (
      (this.source === "order" || this.source === "catalog") &&
      this.automaticBarcodeGenerationEnabled
    ) {
      var missingListings = {};
      ///need to check if it's missing and keep dictionary of products
      this.listings.forEach((listing, index) => {
        if (this.isBarcodeMissing(listing)) {
          missingListings[listing.id] = missingListings[listing.id] || {
            listing: listing,
            indexes: [],
          };
          missingListings[listing.id].indexes.push(index);
        }
      });

      if (Object.keys(missingListings).length > 0) {
        let index = 0;
        let missingListingsIds = Object.keys(missingListings);
        let intervalId = setInterval(() => {
          var listingIndex = index;
          if (listingIndex > Object.keys(missingListings).length - 1) {
            clearInterval(intervalId);
            return;
          }
          let listingId = missingListingsIds[listingIndex];
          let listing = missingListings[listingId].listing;
          this.barcodeCreatedSupermodal.open();
          this.barcodeCreationStatus = `Creating barcode for ${listing.title}`;
          this.listingService.createBarcodes(listing.id).then((listing) => {
            missingListings[listing.id].indexes.forEach((listingIndex) => {
              Object.assign(this.listings[listingIndex], listing);
            });
            this.barcodeCreationStatus = `Barcodes created`;
            setTimeout(() => {
              this.barcodeCreatedSupermodal.close();
            }, 3000);
          });
          index++;
        }, 500);
        // Use `key` and `value`
      }
    }
  }

  protected isBarcodeMissing(listing: Listing): boolean {
    let barcodeMissing =
      !this.listing.barcode || this.listing.barcode.length === 0;
    for (
      let i = 0;
      i < this.listing.variations.length && !barcodeMissing;
      i++
    ) {
      let variation = this.listing.variations[i];
      for (let j = 0; j < variation.options.length && !barcodeMissing; j++) {
        let option = variation.options[i];
        barcodeMissing = !option.barcode || option.barcode.length === 0;
      }
    }
    return barcodeMissing;
  }

  protected createBarcodeIfNeeded() {
    if (
      this.source === "listing" &&
      this.userService.isShopify &&
      this.automaticBarcodeGenerationEnabled &&
      this.isBarcodeMissing(this.listing)
    ) {
      //check that a barcode is missing.
      this.barcodeCreatedSupermodal.open();
      this.barcodeCreationStatus = `Creating barcode for ${this.listing.title}`;
      this.listingService.createBarcodes(this.listing.id).then((listing) => {
        this.listing = listing;
        this.barcodeCreationStatus = `Barcode created`;
        setTimeout(() => {
          this.barcodeCreatedSupermodal.close();
        }, 3000);
      });
    }
  }

  protected download(): Promise<string> {
    return this.listingService.downloadBarcodes(this.listings, this.offset - 1);
  }

  protected includeVariants(): boolean {
    return this.userModel.barcode
      ? this.userModel.barcode.include_variants
      : false;
  }
}
